export default {
  serviceId: /^[a-z][a-z0-9\-_]{5,19}$/,
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // 영어 소문자, 숫자 특수문자 !@#$%^&*()_
  password: /^(?=.*[a-zA-Z])((?=.*\d)).{6,20}$/,
  url: /\b((https?\:)(\/\/))?([-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9]{1,6}([-a-zA-Z0-9@:%_\+.~#?&//=]*))/gi,
};
